<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="productConsumption"
      border
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
    </el-table>
  </div>
</template>

<script>
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        itemLoading: 0,
        currentSort: {
          prop: 'gross_price',
          order: 'desc',
        },
      };
    },
    computed: {
      productConsumption() {
        return this.$store.getters['productConsumption/productConsumption'];
      },
      loading() {
        return this.$store.getters['productConsumption/loading'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['productConsumption/tableConfig']))
      }
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      this.$store.commit('productConsumption/setFilterString', '');
      this.$store.commit('productConsumption/setSorting', this.currentSort);
    },
    methods: {
      handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.$store.commit('stockValue/setSorting', { prop, order });
          this.$store.dispatch('stockValue/fetchAll');
        }
      }
    }
  }
</script>
<style lang="scss">
  .stockValue-table {
    .el-table__footer {
      td {
        .cell {
          font-weight: 700;
        }
      }
    }
  }
</style>

